"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSharedInternalNote = void 0;
const organization_1 = require("./organization");
const user_1 = require("./user");
const utils_1 = require("../utils");
const enums_1 = require("../../utilities/enums");
const base = Object.assign({ id: 1, channel: enums_1.ChannelEnum.InternalNote, organization_id: (0, organization_1.mockChildOrganization)().id, conversation_id: 1, reply_to: null, body: '<p>An internal note</p>', user_id: (0, user_1.mockPreviewUserOne)().id }, utils_1.mockDateObject);
exports.mockSharedInternalNote = (0, utils_1.mockFunction)(Object.assign({}, base));
